import CatalogNew from "../catalog/CatalogNew";

/** Cadastro de serviços com unidade fixa e sem movimentação de estoque. */
const ServiceNew = () => <CatalogNew type="SERVICE" />;

export default ServiceNew;
